import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { InfoPageCanvas } from '@/features/app-shell/canvases/info-page-canvas'

export const Route = createFileRoute('/app/help')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppHelpPage,
})

function AppHelpPage() {
  return (
    <AppShell activePath="/app/help">
      <InfoPageCanvas kind="help" />
    </AppShell>
  )
}
